import type { Category as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import type * as Category from './Category';

/**
 * A category's `{ id, name }` identity slice — the shape the schema embeds where it returns a
 * category without its subcategories, as `AnnounceDetail.category` does.
 *
 * A `Pick<>` of `Category` rather than a redeclared `{ id; name }`, so a rename on the parent is a
 * compile error here too.
 *
 * Splitting it out of `Category.ts` is what lets the mapper be `fromGql`: every type's module exposes
 * that one name, so a caller reaches for `<Module>.fromGql` without looking anything up. Sharing a
 * file forced one of the two to be called something else — this one was `fromGqlFields`.
 */
export type CategorySummary = Pick<Category.Category, 'id' | 'name'>;

export const fromGql = (item: Pick<GQLItem, 'id' | 'name'>): CategorySummary =>
  take<CategorySummary>(item, 'id', 'name');
